<template>
  <!-- hidden PageHeaderWrapper title demo -->
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card>
      <a-form-model ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
        <!-- 标题 -->
        <a-form-model-item label="文章标题" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 7 }, sm: { span: 7 } }" prop="title">
          <a-input placeholder="请输入文章标题" v-model="form.title"> </a-input>
        </a-form-model-item>
        <!-- 类型 -->
        <a-form-model-item label="文章类型" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 7 }, sm: { span: 7 } }" prop="category_id">
          <a-select placeholder="请选择文章类型" v-model="form.category_id">
            <a-select-option :value="value.id" v-for="value in initData.categoryOptions" :key="value.id">{{ value.name
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- 文章来源 -->
        <a-form-model-item label="文章来源" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 7 }, sm: { span: 7 } }" prop="source">
          <a-input placeholder="请输入文章来源" v-model="form.source">
          </a-input>
        </a-form-model-item>
        <!-- 发布范围 -->
        <a-form-model-item label="发布范围" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 7 }, sm: { span: 7 } }" prop="community_ids">
          <a-select placeholder="请选择发布范围" v-model="form.community_ids" mode="multiple">
            <a-select-option :value="value.id" v-for="value in initData.communityOptions" :key="value.id">{{ value.name
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- 文章封面 -->
        <a-form-model-item label="文章封面" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }" prop="cover_image">
          <a-row>
            <a-col :md="16" :sm="24" style="display: flex">
              <div>
                <a-upload showRemoveIcon="true" name="medianews" :show-upload-list="false" list-type="picture-card"
                  :action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload"
                  @change="handleChangenews" v-model="form.cover_image">
                  <dy-image :src="form.cover_image" v-if="form.cover_image" preview>
                  </dy-image>
                  <a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
                </a-upload>
              </div>
              <span style="
                  margin-left: 50px;
                  color: #949393;
                  display: flex;
                  align-items: center;
                ">
                作用于文章列表、分享头图；建议尺寸：750*750像素
              </span>
            </a-col>
          </a-row>
        </a-form-model-item>
        <!-- 图文详情 -->
        <a-form-model-item label="文章内容" :labelCol="{ lg: { span: 2 }, sm: { span: 2 } }"
          :wrapperCol="{ lg: { span: 20 }, sm: { span: 20 } }">
          <!-- <QuillEditor
            style="height: 300px; margin-bottom: 50px"
            ref="quillEditor"
            v-model="form.rich"
          /> -->
          <editor name="editor" v-model="form.body"></editor>
        </a-form-model-item>
        <a-form-model-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-row>
            <a-col>
              <a-button type="primary" style="margin-right: 20px" @click="submit">提交</a-button>
              <a-button style="margin-left: 8px" @click="goBack">取消</a-button>
            </a-col>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import NewsService from "@/io/news/newsList.js";
import newsCategoryService from "@/io/news/newsCategory.js";
import CommunityService from "@/io/community.js";

export default {
  name: "Createnews",
  data() {
    return {
      categoryResData: {
        data: [
          {
            id: 5,
            name: "游戏",
            remarks: "游戏文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:31",
          },
          {
            id: 4,
            name: "育儿",
            remarks: "育儿文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:24",
          },
          {
            id: 3,
            name: "旅游",
            remarks: "旅游文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:18",
          },
          {
            id: 2,
            name: "健康",
            remarks: "健康文章类型",
            status: 1,
            created_at: "2022-03-29 10:48:10",
          },
          {
            id: 1,
            name: "生活",
            remarks: "生活文章类型",
            status: 1,
            created_at: "2022-03-29 10:47:46",
          },
        ],
        meta: {
          pagination: {
            total: 5,
            count: 5,
            per_page: 15,
            current_page: 1,
            total_pages: 1,
            links: [],
          },
        },
      },
      detailResData: {
        id: 2,
        title: "万事屋有约Vol.1｜本屋开张的第50天",
        category_id: 1,
        category: "生活",
        source: "社区发布",
        community_ids: ["101"],
        cover_image:
          "https://cdn.tjsq.tjo2o.cn/attachments/images/202012/27/GMJa2KB7FPpQCbhkDEoHo39peEh5yDmlQF12sGno.jpeg",
        body: "一转眼，本万事屋开张已经50天了！本屋主为了和各个小组多多联动起来，目前我们正在积极筹划各类小组活动赞助，还遇见了好多可爱组鹅，大声感叹小组太有意思了！\n\n\n\n本屋每天一边快乐冲浪一边陷入思考，这么多神奇的小组都是哪里冒出来的呢？想来想去，还是决定亲自拜访，听一听组长们的故事。",
        status: 1,
        created_at: "2022-03-30 16:25:28",
      },
      initData: {
        categoryOptions: [],
        communityOptions: [],
      },
      avatar: {
        newsLoading: false,
        bannerLoading: false,
      },
      form: {
        title: null,
        category_id: [],
        source: null,
        community_ids: [],
        cover_image: null,
        body: null,
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入文章标题",
          },
        ],
        category_id: [
          {
            required: true,
            message: "请选择文章类型",
          },
        ],
        source: [
          {
            required: true,
            message: "请输入文章来源",
          },
        ],
        community_ids: [
          {
            required: true,
            message: "请选择发布范围",
          },
        ],
        cover_image: [
          {
            required: true,
            message: "请上传文章封面",
          },
        ],
        body: [
          {
            required: true,
            message: "请填写文章内容",
          },
        ],
      },
      previewVisible: false,
      previewImage: "",
    };
  },
  mounted() {
    this.initSelectData();
    this.initnewsDetialData();
  },
  methods: {
    cancelImg() {
      this.$message.info('陈工')
    },
    // 提交
    submit() {
      this.$beforeFormSubmit(this.$refs.form, async () => {
        const { title, category_id, source, community_ids, cover_image, body } =
          this.form;
        if (!this.$route.params.id) {
          // 适用服务id
          const res = await NewsService.add(
            title,
            category_id,
            source,
            community_ids,
            cover_image,
            body
          );
          this.$afterFormSubmit("创建成功", () => {
            this.$router.push("/platform/newslist");
          });
        } else {
          const res = await NewsService.update(
            Number(this.$route.params.id),
            title,
            category_id,
            source,
            community_ids,
            cover_image,
            body
          );
          this.$afterFormSubmit("修改成功", () => {
            this.$router.push("/platform/newslist");
          });
        }
      });
    },
    // 初始化选择框数据
    async initSelectData() {
      // 文章类型
      // 假数据
      // const resCategory = this.categoryResData
      const resCategory = await newsCategoryService.list();
      this.initData.categoryOptions = resCategory;
      // 社区列表
      this.initData.communityOptions = await CommunityService.listPage();
    },
    // 编辑页面获取文章数据
    async initnewsDetialData() {
      if (this.$route.params.id) {
        const res = await NewsService.detail(this.$route.params.id);
        // const res = this.detailResData;
        this.form.title = res.title;
        this.form.category_id = res.category_id;
        this.form.source = res.source;
        this.form.community_ids = res.community_ids.map((val) => {
          return Number(val);
        });
        this.form.cover_image = res.cover_image;
        this.form.body = res.body;
      }
    },
    // 上传文章图片
    handleChangenews(info) {
      let status = info.file.status;
      if (status) {
        if (status === "done") {
          this.avatar.newsLoading = false;
          this.form.cover_image = info.file.response.medianews;
        } else {
          this.avatar.newsLoading = true;
        }
      }
    },
    goBack() {
      this.$router.push("/platform/newslist");
    },
  },
};
</script>
<style lang="less" scoped>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.row-box {
  display: flex;
}

.tip {
  display: flex;
  align-items: center;
  margin-left: 50px;
  // margin-bottom: 20px;
  color: #949393;
}
</style>
